import { LoadingStage, LoadingState, LoadingStateNoError } from 'app/containers/state/LoadingState';

/**
 * Small helper to be combined with AutoLoader or makeCachedLoader
 *
 * Throws an error when the loading state is in the error stage, which can be
 * used to trigger a React error boundary such as our <ErrorErrorBoundaryPage>
 * component.
 */
export default function throwOnError<ValueType, RestType>(
  loadingState: LoadingState<ValueType> & RestType,
): LoadingStateNoError<ValueType> & RestType {
  if (loadingState.stage === LoadingStage.Error) {
    throw loadingState.error;
  }

  return loadingState;
}
